import type { ModeEnum, UpdateActionEnum } from './types';

export type Aggregation = {
  Name: string;
  DisplayName: string;
  AggregationType: AggregationType;
  UpdateAction?: UpdateActionEnum;
  FairPriceProtection?: boolean;
};

export interface AggregationWithAccounts extends Aggregation {
  Accounts: Map<string, AggregationMarket>;
}

export interface AggregationMarket {
  Aggregation: string;
  Market?: string;
  MarketAccount?: string;
  Mode: ModeEnum;
  UpdateAction?: UpdateActionEnum;
  // RowID for Customer Aggregations Blotter
  RowID?: string;
}

// This is the response model for /aggregations?expanded=true
export interface ExtendedAggregationForEA extends Omit<AggregationMarket, 'Mode'> {
  // "Aggregation" is being used instead of Name
  AggregationType?: AggregationType;
  DisplayName?: string;
  Mode?: ModeEnum;
}

export enum AggregationType {
  Customer = 'Customer',
  System = 'System',
  User = 'User',
}
